import React, { useState } from 'react';
import { orderReference } from '../lib/orderReference';
export default function CustomerDeliveryHistory({ deliveries = [], expanded = false, hideToggle = false }) {
  const [open, setOpen] = useState(expanded);
  return <div className="mt-2 text-sm">
    {!hideToggle && <button type="button" aria-expanded={open} onClick={() => setOpen(value => !value)} className="font-semibold text-primary">{open ? 'Hide' : 'View'} delivery history ({deliveries.length})</button>}
    {open && <div className="mt-2 space-y-3">{!deliveries.length && <p>No successful deliveries yet.</p>}{deliveries.map((delivery, index) => <div key={delivery.orderId || index} className="space-y-1 rounded-lg border p-3">
      <p className="font-bold">Order #{orderReference(delivery.orderId)}</p>
      {delivery.deliveredAt && <p>{new Date(delivery.deliveredAt).toLocaleString()}</p>}
      {delivery.address && <p>{delivery.address}</p>}
      {delivery.note && <p className="whitespace-pre-wrap">Delivery note: {delivery.note}</p>}
      {delivery.proofPhoto ? <a href={delivery.proofPhoto} target="_blank" rel="noreferrer"><img alt="Delivery proof" src={delivery.proofPhoto} className="max-h-72 w-full rounded-lg object-contain" /></a> : <p>No proof photo available.</p>}
    </div>)}</div>}
  </div>;
}
